import { FeatureFlag } from '../../enums/FeatureFlag';
import type { EffectParams } from '../../types';

import type { Feature } from './feature';

const effects: { check(_payload: unknown, params: EffectParams): Promise<void> } = {
  async check(_payload, { dispatch, request }) {
    const { body } = await request<Feature>({
      service: 'features.check',
      body: { features: Object.values(FeatureFlag) }
    });

    dispatch.feature.update(body);
  }
};

export default effects;
